module.exports = __webpack_public_path__ + "img/2021_09_dande_arashiyama_fin_web.a909e3ff.jpg";